import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardActions, CardContent, Checkbox, CircularProgress, Container, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, InputLabel, MenuItem, Modal, Paper, Radio, RadioGroup, Select, SelectChangeEvent, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { themePalette, themePaletteEstados } from "../../config/theme.config";
import { FaCalendarCheck, FaCaretDown, FaCaretUp, FaCheck, FaEdit, FaEye, FaEyeSlash, FaPaperPlane, FaPlus, FaPlusCircle, FaQuestionCircle, FaRegCalendarTimes, FaRegCircle, FaTimesCircle, FaTrash, FaUpload } from "react-icons/fa";
import { useEffect, useState } from "react";
import { Pagina } from "../../types/Plantillas/Pagina";
import { styled } from '@mui/material/styles';
import dayjs, { Dayjs } from "dayjs";
import { DateTime } from "luxon";
import { TimePicker } from "@mui/x-date-pickers";
import { Plantilla } from "../../types/Plantillas/Plantilla";
import placeholderImage from '../../assets/img/placeholder-image.jpg';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Campania } from "../../types/Campanias/Campania";
import StyledBox from "../../componente/Plantillas/StyledBox";
import IphoneBox from "../../componente/Plantillas/IphoneBox";
import ModalContainerBox from "../../componente/Plantillas/ModalContainerBox";
import ConfirmationModal from "../../common/Modal/ConfirmationsModal";
import CampaniaService from "../../services/CampaniaService";
import { AudienciaCampania } from "../../types/Campanias/AudienciaCampania";
import { Campanium } from "../../types/Campanias/Campanium";
import PlantillaService from "../../services/PlantillaService";
import { current } from "@reduxjs/toolkit";
import { number } from "prop-types";


// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export const CampaniasPage: React.FC<{}> = () => {
    const [justLook, setJustLook] = useState(false);
    const [justEditing, setJustEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingPlantilla, setLoadingPlantilla] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenDetalle, setIsOpenDetalle] = useState(false);
    const [isOpenConfirmacion, setIsOpenConfirmacion] = useState(false);
    const [selectedSegments, setSelectedSegments] = useState<number[]>([]);
    const [errors, setErrors] = useState({ plantillaId: false, fecha: false, hora: false, envioInmediato: false ,segment: false });
    const [fecha, setFecha] = useState<Dayjs | null>(dayjs(DateTime.now().toFormat('yyyy-MM-dd')));
    const [fechaHora, setFechaHora] = useState<Dayjs | null>(dayjs(DateTime.now().toFormat('yyyy-MM-dd')));
    const [plantillaId, setPlantillaId] = useState('');
    const [currentplantillaId, setCurrentPlantillaId] = useState('');
    const [tab, setTab] = useState(0);
    const [segmentList, setSegmentList] = useState<Array<AudienciaCampania>>([]);
    const [currentCampania, setCurrentCampania] = useState<Campania>(new Campania(
      "",
      "",
      "",
      "",
      "",
      false,
      []
    ));
    const [currentPlantilla, setCurrentPlantilla] = useState<Plantilla>(new Plantilla(
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        false,
        '',
        ''
    ));
    const [plantillas, setPlantillas] = useState<Map<string, Plantilla>>(new Map<string, Plantilla>());
    const [rows, setRows] = useState<any[]>([]);

    const fetchSegmentos = async () => {
      setLoading(true)
      try {
          const response = await CampaniaService.GetSegmentos();
          setSegmentList(response);
      } catch (error) {
          console.error(error)
      } finally {
          setLoading(false)
      }
    }

    const fetchPlantillas = async () => {
      setLoading(true)
      try {
          const response = await PlantillaService.GetPlantillasMap();
          setPlantillas(response);
          
      } catch (error) {
          console.error(error)
      } finally {
        setLoading(false)
        
      }
      
    }

    const fetchCampanias = async () => {
      setLoading(true)
      try {
          const response = await CampaniaService.GetCampanias();

          setRows(CampaniaService.createFilas(response.map(
            (camp) => Campania.construirPorCampanium(camp)
          )));

          
      } catch (error) {
          console.error(error)
      } finally {
          setLoading(false)
      }
    }


    const [editedCampaña, setEditedCampaña] = useState<Campania>(
      new Campania(
        "",
        "",
        "",
        "",
        "",
        false,
        []
      )
    );

    const validateSegments = () => {
      if(currentCampania?.segmentos.length === 0){
        setErrors(prevErrors => ({
          ...prevErrors,
          segment: true
        }));
      }else{
        setErrors(prevErrors => ({
          ...prevErrors,
          segment: false
        }));
      }
    };

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
      setTab(newValue);
    };
    
    const validateFechaHora = () => {
      if (!fechaHora || !fecha) {
        setErrors((prev) => ({ ...prev, fecha: true }));
        setErrors((prev) => ({ ...prev, hora: true }));
        return; // Validation failed due to missing data
      }
    
      // Combine fecha's date with hora's time
      const combinedDateTime = dayjs(fecha)
        .set('hour', fechaHora.hour())
        .set('minute', fechaHora.minute());

      
    
      if (combinedDateTime.isBefore(dayjs().tz("America/Guayaquil"))) {
        console.log('Error');
        console.log(dayjs().tz("America/Guayaquil"));
        console.log(combinedDateTime);
        setErrors((prev) => ({ ...prev, fecha: true }));
        setErrors((prev) => ({ ...prev, hora: true }));
      } else {
        console.log('Correcto');
        console.log(dayjs().tz("America/Guayaquil"));
        console.log(combinedDateTime);
        setErrors((prev) => ({ ...prev, fecha: false }));
        setErrors((prev) => ({ ...prev, hora: false }));
      }
    };

    const handleCheckboxChange = (index: number) => {

      let newSelected: number[] = [];

      console.log(" Indice seleccionado: "+ index);

      if (segmentList[index].descripcion.toLocaleLowerCase() === 'todos') {
        for(var i = 0; i < segmentList.length; i++){
          if(i != index){
            newSelected.push(i);
          }
        }
      } else {
        // Agrega o quita el índice actual normalmente
        newSelected = currentCampania?.segmentos.includes(index)
          ? currentCampania!.segmentos.filter((i) => i !== index) // Deselect
          : [...(currentCampania!.segmentos ?? []), index];       // Select
      }

      currentCampania?.setSegmentos(newSelected);
      setCurrentCampania(currentCampania);

      validateSegments();
    };

    const handleChange = (event: SelectChangeEvent) => {
      setLoadingPlantilla(true);
  
      const newPlantillaId = event.target.value as string;
  
      if (currentCampania) {
          currentCampania.setPlantillaId(newPlantillaId);
          setCurrentCampania(currentCampania); // Ensures state update
      }
  
      setCurrentPlantilla(plantillas.get(newPlantillaId.toString())!);
  
      console.log("Plantilla Value:", plantillas.get(newPlantillaId.toString()));

    };
  
  
    const validateField = (field: string, value: string) => { 
      if(!justLook){
        setErrors((prev) => ({
          ...prev,
          [field]: value === ''
        }));
      }
    };

    useEffect(() => {
      fetchCampanias();
      fetchPlantillas();
      fetchSegmentos();
    }, []);

    function emptyForm(){

      currentCampania.setPlantillaId("");
      currentCampania.setEnvioInmediato(false);
      currentCampania.setFechaProg("");
      currentCampania.setHoraProg("");
      currentCampania.setSegmentos([]);
      setCurrentCampania(currentCampania);
      setCurrentPlantilla(
        new Plantilla(
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          false,
          '',
          ''
        )
      );

      setPlantillaId("");
      setFecha(null);
      setFechaHora(null);
      
      setErrors(prevErrors => ({
        ...prevErrors,
        plantillaId: false,
        fecha: false,
        hora: false,
        envioInmediato: false,
        segment: false
      }));

      if(justLook){
        setJustLook(false);
      }else if(justEditing){
        setJustEditing(false);
      }

      setIsOpen(false);
      // console.log("res plantillaId: "+currentCampania.plantillaId);
    }

    function fillForm(row: Campania){

      setLoading(true);

      currentCampania.setPlantillaId(row.plantillaId);
      currentCampania.setEnvioInmediato(row.envioInmediato);
      currentCampania.setSegmentos(row.segmentos);
      currentCampania.setFechaProg(row.fechaProg);
      currentCampania.setHoraProg(row.horaProg);
      setCurrentCampania(currentCampania);
      setCurrentPlantilla(plantillas.get(row.plantillaId)!);
      
      setPlantillaId(row.plantillaId);
      setCurrentPlantillaId(row.plantillaId);

      setFecha(dayjs(row.fechaProg));
      setFechaHora(dayjs(row.fechaProg+" "+row.horaProg));
      // setEnvioInmediato(row.envioInmediato);
      setSelectedSegments(row.segmentos);

      console.log("plantilla id: "+row.plantillaId);
      console.log("plantilla id: "+row);

      setLoading(false);
      
    }
    
    return (
        <div>
            <Container
                maxWidth="lg"
                style={{
                    marginTop: 10,
                    padding: '10px',
                    marginLeft: '15vw',
                }}
                >
                <Box
                    sx={{
                    display: 'flex',
                    justifyContent: 'space-between', // Position items at opposite ends
                    alignItems: 'center', // Vertically align items
                    }}
                >
                    {/* Box with the text */}
                    <Box>
                    <Typography
                        variant="h6"
                        gutterBottom
                        style={{
                        paddingBottom: '1%',
                        color: `${themePalette.BONDIBLUE}`,
                        fontSize: '1.25rem', // Custom size
                        }}
                    >
                        CAMPAÑAS
                    </Typography>
                    </Box>

                    {/* Button on the other end */}
                    <Button
                      variant="outlined"
                      endIcon={<FaPlusCircle />}
                      style={{
                          color: `${themePalette.BONDIBLUE}`, // Light blue text
                          borderColor: `${themePalette.BONDIBLUE}`, // Light blue border
                          textTransform: 'none', // Prevent uppercase transformation
                          borderRadius: '50px', // Circular borders
                          padding: '5px 20px', // Adjust padding for aesthetics
                      }}
                      onClick={() => {
                          setIsOpen(true);
                      }}
                    >
                      Crear
                    </Button>
                </Box>
            </Container>
            {loading ? (
                <CircularProgress />
            ) : (
              <Container maxWidth="lg" style={{ marginTop: 10, marginLeft: '15vw', marginRight: '30vw', padding: '20px', textAlign: 'center', border: `1px solid ${themePalette.BONDIBLUE}`, borderRadius: '5px' }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: themePalette.BONDIBLUE }}>
                                <TableCell align="center" sx={{ color: 'white' }}>Plantilla</TableCell>
                                <TableCell align="center" sx={{ color: 'white' }}>Fecha programada</TableCell>
                                <TableCell align="center" sx={{ color: 'white' }}>Hora programada</TableCell>
                                <TableCell align="center" sx={{ color: 'white' }}>Estado</TableCell>
                                <TableCell align="center" sx={{ color: 'white' }}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {rows.map((row) => (
                            <TableRow
                            key={row.plantillaId}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                            <TableCell component="th" scope="row" align="center" sx={{fontSize:"12px"}}>
                                {row.plantillaId}
                            </TableCell>
                            <TableCell align="center" sx={{fontSize:"12px",}}>
                                {row.fecha}
                            </TableCell>
                            <TableCell align="center" sx={{fontSize:"12px",}}>{row.hora}</TableCell>
                            <TableCell align="center" sx={{ fontSize: "12px" }}>
                                <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-around',
                                    alignItems: 'center',
                                    gap: '10px', // Spacing between icons
                                }}
                                >
                                    {/* First Icon with Name */}
                                    <Box sx={{ textAlign: 'center' }}>
                                        <IconButton
                                          sx={{ color: row.estado !== "E" ? themePalette.WHITESMOKE :  themePalette.BONDIBLUE }}
                                          aria-label="view"
                                          onClick={() => {}}
                                        >
                                        <FaPaperPlane />
                                        </IconButton>
                                        <Typography sx={{ fontSize: "0.5rem", marginTop: '4px', color: `${themePalette.WHITESMOKE}` }}>Enviado</Typography>
                                    </Box>

                                    {/* Second Icon with Name */}
                                    <Box sx={{ textAlign: 'center' }}>
                                        <IconButton
                                        sx={{ color: row.estado !== "C" ? themePalette.WHITESMOKE :  "warning"}}
                                        aria-label="edit"
                                        onClick={() => {}}
                                        >
                                        <FaRegCalendarTimes  />
                                        </IconButton>
                                        <Typography sx={{ fontSize: "0.5rem", marginTop: '4px', color: `${themePalette.WHITESMOKE}` }}>Cancelado</Typography>
                                    </Box>

                                    {/* Third Icon with Name */}
                                    <Box sx={{ textAlign: 'center' }}>
                                        <IconButton
                                        sx={{ color: row.estado !== "P" ? themePalette.WHITESMOKE :  themePalette.MARIAN_BLUE }}
                                        aria-label="delete"
                                        onClick={() => { }}
                                        >
                                        <FaCalendarCheck />
                                        </IconButton>
                                        <Typography sx={{ fontSize: "0.5rem", marginTop: '4px', color: `${themePalette.WHITESMOKE}`, }}>Planificado</Typography>
                                    </Box>
                                </Box>
                            </TableCell>
                            <TableCell align="center" sx={{fontSize:"0.6rem"}}>
                                {/* Add two IconButtons for editing and deleting */}
                                <IconButton sx={{color: themePalette.WHITESMOKE}} aria-label="peek" onClick={() => {
                                      console.log("Peek action - plantilla de campaña: "+row.plantillaId);
                                      fillForm(row.campaña);
                                      setJustLook(true);
                                      setIsOpen(true);
                                    }
                                }
                                >
                                  <FaEye />
                                </IconButton>
                                <IconButton sx={{color: themePalette.BONDIBLUE}} aria-label="edit" onClick={() => {
                                      console.log("Edit action: ")
                                      fillForm(row.campaña);
                                      setJustEditing(true);
                                      setIsOpen(true);
                                    }
                                }>
                                    <FaEdit />
                                </IconButton>
                                <IconButton 
                                  sx={{color: themePaletteEstados.RECHAZADO}} 
                                  aria-label="cancel" 
                                  onClick={() => {
                                      setIsOpenConfirmacion(true);
                                    }
                                  }
                                >
                                  <FaTimesCircle></FaTimesCircle>
                                </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
            )}
            
            {loading ? (
                <CircularProgress />
            ) : (
              <Modal open={isOpen} onClose={() => {
                  emptyForm()
                }
              }>
                <Box sx={{
                  display: 'inline',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '75vw',
                  height:'55vh',
                  bgcolor: 'background.paper',
                  boxShadow: 24,
                  overflow: 'auto',
                  p: 4,
                }}>
                  <button
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'transparent',
                      border: 'none',
                      fontSize: '18px',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      emptyForm()
                    }}
                  >
                    ✖
                  </button>
                  <Typography marginTop={'1vh'} marginBottom={'2vh'} variant="body1" component="p" style={{color: `${themePalette.BONDIBLUE}`,}} gutterBottom >
                    Crear / Editar
                  </Typography>
                  <Box 
                    sx={{
                      display:'flex',
                      flexDirection:'row',
                      marginBottom:'5vh'
                    }}
                  >
                    <FormControl sx={{width:'25vw'}}>
                      <FormLabel 
                        id="plantilla" 
                        sx={
                            {
                              color:  `${themePalette.GAINSBORO}`, 
                              fontSize: '10px',
                              '&.Mui-focused': {
                                  color: `${themePalette.GAINSBORO}`, // Color when selected
                              },
                            }
                          }
                        >
                        Plantilla
                      </FormLabel>
                      <Select
                        labelId="l-plantilla"
                        disabled= {justLook}
                        id="plantilla"
                        value={currentCampania?.plantillaId}
                        // label="Plantilla"
                        onChange={handleChange}
                        onBlur={() => {
                            validateField('plantillaId', currentCampania?.plantillaId ?? '')
                          }
                        }
                        error={errors.plantillaId}
                      >
                        {Array.from(plantillas.values()).map((item) =>(
                          <MenuItem value={item.id}>{item.descripcion}</MenuItem>
                        ))}
                      </Select>
                      {errors.plantillaId && <FormHelperText error={errors.plantillaId}>Este campo es obligatorio</FormHelperText>}
                    </FormControl>
                    {/* Botón de ayuda*/}
                    <IconButton
                      aria-label="view"
                      onClick={() => {
                        console.log(currentPlantilla);
                        if(currentPlantilla!=null){
                          setLoadingPlantilla(false);
                          setIsOpenDetalle(true);
                        }
                        
                      }}
                      sx={{
                        marginTop: '17.5px',
                        height: '40px',
                        marginRight:'0.5vw'
                      }}
                    >
                      <FaQuestionCircle />
                    </IconButton>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <FormControl>
                        <FormLabel 
                          id="fecha" 
                          sx={
                              {
                                color:  `${themePalette.GAINSBORO}`, 
                                fontSize: '10px',
                                '&.Mui-focused': {
                                    color: `${themePalette.BONDIBLUE}`, // Color when selected
                                },
                              }
                            }
                        >
                          Fecha
                        </FormLabel>
                        <DatePicker
                          sx={{
                            width:'10vw',
                            maxHeight:'10vh',
                            color: `${themePalette.GAINSBORO}`
                          }}
                          label=""
                          disabled={justLook}
                          value={fecha}
                          onChange={(newValue) => {
                              setFecha(newValue);
                              currentCampania?.setFechaProg(newValue!.toString() ?? "");
                              setCurrentCampania(currentCampania);
                            }
                          }
                        />
                        {errors.fecha && <FormHelperText 
                          error={errors.fecha} 
                          sx={{ 
                            mt: '2px',       // Reduce top margin
                            fontSize: '9px', // Smaller font size
                            lineHeight: '1.2' // Tighter line height
                          }}
                        >
                          Seleccione una fecha válida
                        </FormHelperText>}
                      </FormControl>
                      <FormControl sx={{marginLeft: '1vw',}}>
                        <FormLabel 
                          id="hora" 
                          sx={
                              {
                                color:  `${themePalette.GAINSBORO}`, 
                                fontSize: '10px',
                                '&.Mui-focused': {
                                    color: `${themePalette.BONDIBLUE}`, // Color when selected
                                },
                              }
                            }
                          >
                          Hora
                        </FormLabel>
                        <TimePicker
                          value={fechaHora}
                          disabled = {justLook || !fecha}
                          onChange={(newValue) => {
                              setFechaHora(newValue)
                              currentCampania?.setHoraProg(newValue!.toString() ?? "");
                              setCurrentCampania(currentCampania);
                              validateFechaHora();
                            }
                          }
                          onAccept={validateFechaHora}
                          sx={{
                            width:'10vw',
                            color: `${themePalette.GAINSBORO}`,
                            maxHeight:'10vh'
                          }}
                        />
                        {errors.hora && <FormHelperText 
                          error={errors.hora} 
                          sx={{ 
                            mt: '2px',       // Reduce top margin
                            fontSize: '9px', // Smaller font size
                            lineHeight: '1.2' // Tighter line height
                          }}
                        >
                          Seleccione una hora válida
                        </FormHelperText>}
                      </FormControl>
                    </LocalizationProvider>
                    <FormControl sx={{ marginLeft: '1vw' }}>
                      <FormLabel 
                        id="envioInmediato" 
                        sx={
                            {
                              color:  `${themePalette.GAINSBORO}`, 
                              '&.Mui-focused': {
                                  color: `${themePalette.GAINSBORO}`, // Color when selected
                              },
                            }
                          }
                      >
                        Envio Inmediato
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="envioInmediato"
                        name="row-radio-envioInmediato"
                        onBlur={() => validateField('envioInmediato', currentCampania?.envioInmediato.toString() ?? '')}
                        sx={{ gap: '6vw' }} // Adds space between options
                      >
                        <FormControlLabel
                          disabled={justLook}
                          checked={currentCampania?.envioInmediato}
                          onClick={() => {
                              currentCampania?.setEnvioInmediato(true);
                              setCurrentCampania(currentCampania);
                              validateField('envioInmediato', currentCampania?.envioInmediato.toString() ?? '');
                            }
                          }
                          value={true}
                          control={
                            <Radio
                              disabled={justLook}
                              checked={currentCampania?.envioInmediato}
                              sx={{
                                color: `${themePalette.GAINSBORO}`,
                                '&.Mui-checked': {
                                  color: `${themePalette.BONDIBLUE}`, // Color when selected
                                },
                              }}
                            />
                          }
                          style={{
                            color: `${themePalette.GAINSBORO}`,
                          }}
                          sx={{
                            marginLeft:'5vw'
                          }}
                          labelPlacement="start"
                          label="Sí"
                        />
                        <FormControlLabel
                          disabled={justLook}
                          checked={!currentCampania?.envioInmediato}
                          onClick={() => {
                              currentCampania?.setEnvioInmediato(false);
                              setCurrentCampania(currentCampania);
                              validateField('envioInmediato', currentCampania?.envioInmediato.toString() ?? '');
                            }
                          }
                          value={false}
                          control={
                            <Radio
                              disabled={justLook}
                              checked={!currentCampania?.envioInmediato}
                              sx={{
                                color: `${themePalette.GAINSBORO}`,
                                '&.Mui-checked': {
                                  color: `${themePalette.BONDIBLUE}`, // Color when selected
                                },
                              }}
                            />
                          }
                          style={{
                            color: `${themePalette.GAINSBORO}`,
                          }}
                          label="No"
                          labelPlacement="start"
                        />
                      </RadioGroup>
                      {errors.envioInmediato && (
                        <FormHelperText error={errors.envioInmediato}>
                          Este campo es obligatorio
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                  
                  <Typography marginTop={'1vh'} variant="body1" component="p" style={{color: `${themePalette.BONDIBLUE}`,}} gutterBottom >
                    Segmentos
                  </Typography>
                  {segmentList.map((segment, index) => (
                  <FormControlLabel
                      key={index+1}
                      control={
                        <Checkbox
                          checked={currentCampania!.segmentos.includes(index)}
                          disabled={justLook}
                          onChange={() => handleCheckboxChange(index)}
                          onBlur={validateSegments}  // Trigger validation on blur
                          sx={{
                            color: `${themePalette.GAINSBORO}`,
                            '&.Mui-checked': {
                              color: `${themePalette.BONDIBLUE}`, // Color when selected
                            },
                          }}
                        />
                      }
                      value={segment.idAudiencia}
                      label={segment.descripcion}
                      labelPlacement="start" // Position the label on the left
                      sx={{
                        '& .MuiFormControlLabel-label': {
                            color: `${themePalette.GAINSBORO}`,
                        },
                      }}
                    />
                    ))}
                    {errors.segment && <FormHelperText error={errors.segment}>Este campo es obligatorio</FormHelperText>}
                    <Box sx={{ display: 'flex', justifyContent: 'center',mt: 3, width: '100%', alignItems:'center', paddingLeft:'5vw'}}>
                      <Button
                        disabled={justLook}
                        type="submit" 
                          variant="contained" 
                          onClick={async () => {
                            // if(justEditing){
                              
                            // }

                            // console.log(fechaHora!);
                            const fechaHoraStr = fechaHora ? fechaHora.format('YYYY-MM-DD HH:mm:ss') : '';

                            setEditedCampaña(
                              new Campania(
                                justEditing ? currentCampania!.idCampania : '0',
                                currentPlantilla!.id!,
                                fechaHoraStr.split(' ')[0],
                                fechaHoraStr.split(' ')[1],
                                justEditing ? currentCampania.estado : "P",
                                currentCampania!.envioInmediato,
                                currentCampania!.segmentos
                              )
                            );

                            var campanium = new Campanium(
                              justEditing ? parseInt(currentCampania!.idCampania) : 0,
                              0,
                              parseInt(currentPlantilla!.id!),
                              0,
                              0,
                              'P',
                              fechaHoraStr,
                              '',
                              '',
                              []
                            );

                            campanium.getSelectedSegmentos(segmentList, currentCampania.segmentos);
                            
                            console.log(campanium);
                          }}
                          sx={
                            { ml: 2, 
                              backgroundColor: '#0A2C6B', '&:hover': 
                              {
                                backgroundColor: '#082354'  // Darker shade for hover effect
                              },
                              marginRight: '5vw',
                              width: '10vw',
                              height: '5vh'
                            }
                          }
                      >
                        Guardar
                      </Button>
                    </Box>
                </Box>
              
            </Modal>
            )}
            
          
          {(!loadingPlantilla  && (
            <Modal open={isOpenDetalle} onClose={() => {
                  setIsOpenDetalle(false);
                }
              }
            >
              <Box sx={{
                display: 'inline',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '75vw',
                height:'80vh',
                bgcolor: 'background.paper',
                boxShadow: 24,
                overflow: 'auto',
                p: 4,
              }}>
                <button
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    background: 'transparent',
                    border: 'none',
                    fontSize: '18px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setIsOpenDetalle(false);
                  }}
                >
                  ✖
                </button>
                
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography marginTop={'1vh'} marginBottom={'2vh'} variant="body1" component="p" style={{color: `${themePalette.BONDIBLUE}`,}} gutterBottom >
                      Detalle de Plantilla
                    </Typography>
                    <Card variant="outlined" sx={{ width: '32.5vw'}}>
                      <CardContent>
                        <Box sx={{ display: 'flex' }}>
                          <Tabs
                          value={tab}
                          onChange={handleTabChange}
                          aria-label="Pestañas interactivas"
                          sx={{ borderBottom: 1, borderColor: 'divider' }}
                          >
                              <Tab label="Estado Inicial" id="tab-0" aria-controls="tabpanel-0" sx={{
                                '&.Mui-selected': {
                                  color: themePalette.BONDIBLUE, // Change selected tab text color
                                },
                              }}/>
                              <Tab label= "Vista expandida" id="tab-1" aria-controls="tabpanel-1" sx={{
                                '&.Mui-selected': {
                                  color: themePalette.BONDIBLUE, // Change selected tab text color
                                },
                              }}/>
                          </Tabs>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <StyledBox>
                            <Box
                              sx={{
                                border: '4px solid gray',
                                borderRadius: '12px',
                                display: 'flex',
                                flexDirection: tab == 1 ? 'column' : 'row',
                                justifyContent: tab == 1 ? 'left' : 'space-between',
                                alignItems: 'left',
                                width: '340px',
                                height: tab == 1 ? '165px' : '80px',
                                marginTop: tab == 1 ? '200px' : '120px',
                                marginLeft: '15px',
                                padding: '5px'
                              }}
                            >
                              <Box>
                                <Typography
                                  style={{
                                    fontSize: '14px', // Custom size
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {currentPlantilla.titulo ?? ""}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '10px', // Custom size
                                    display: '-webkit-box', // Multi-line ellipsis for tab !== 1
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    WebkitLineClamp: tab !== 1 ? 2 : 2, // Limit to 2 lines
                                  }}
                                >
                                  { currentPlantilla.contenido ?? ""}
                                </Typography>
                              </Box>
                              {tab === 1 && (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '95px'
                                  }}
                                >
                                  <img 
                                    src={ (currentPlantilla.urlImagen === null || currentPlantilla.urlImagen === '') ? placeholderImage : currentPlantilla.urlImagen ?? ""}
                                    alt="icon" 
                                    style={{ height: '100%', width: '100%', objectFit: 'contain' }}
                                  />
                                </Box>
                              )}
                              {tab === 0 && (
                                <img 
                                src={ (currentPlantilla.urlImagen === null || currentPlantilla.urlImagen === '') ? placeholderImage : currentPlantilla.urlImagen ?? ""}
                                  alt="icon" 
                                  style={{ height: '50px', width: '50px' }} 
                                />
                              )}
                              
                            </Box>
                          </StyledBox>

                          <Box sx={{justifyContent: 'center', alignItems:'center', width: '500px', display: 'flex',}}>
                            <Typography
                              style={{
                                marginTop: tab === 0 ? '30px' : '100px',
                                color: '#6B6C6C', // Custom size
                              }}
                            >
                              Android
                            </Typography>
                          </Box>

                          <IphoneBox>
                            <Box
                              sx={{
                                border: '4px solid gray',
                                display: 'flex',
                                borderRadius: '12px',
                                flexDirection: tab == 1 ? 'column' : 'row',
                                justifyContent: tab == 1 ? 'left' : 'space-between',
                                // alignItems: 'center',
                                width: '300px',
                                height: tab == 1 ? '180px' : '100px',
                                marginTop: tab == 1 ? '150px' : '70px',
                                marginLeft: '2.5px',
                                padding: '5px'
                              }}
                            >
                                { tab === 1 && (
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100px'
                                      }}
                                    >
                                      <img 
                                        src={ (currentPlantilla.urlImagen === null || currentPlantilla.urlImagen === '') ? placeholderImage : currentPlantilla.urlImagen}
                                        alt="icon" 
                                        style={{ height: '100%', width: '50%', objectFit: 'contain' }} 
                                      />
                                    </Box>
                                      
                                )}
                                <Box
                                  sx={{
                                    marginTop: tab === 1 ? '0px' : '7.5px',
                                  }}
                                >
                                  <Typography 
                                    style={{
                                      fontSize: '14px', // Custom size
                                      fontWeight: 'bold'
                                    }}>
                                    {currentPlantilla.titulo ?? ""}
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontSize: '10px', // Custom size
                                      display: '-webkit-box', // Multi-line ellipsis for tab !== 1
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      WebkitLineClamp: tab !== 1 ? 2 : 3, // Limit to 2 lines
                                    }}
                                  >
                                    {currentPlantilla.contenido ?? ""}
                                  </Typography>
                                </Box>
                                
                                { tab === 0 && (
                                  <img 
                                    src={ (currentPlantilla.urlImagen === null || currentPlantilla.urlImagen === '') ? placeholderImage : currentPlantilla.urlImagen} 
                                    alt="icon" 
                                    style={{ height: '60px', width: '60px' }} 
                                  />
                                )}  
                            </Box>
                          </IphoneBox>
                          <Box sx={{justifyContent: 'center', alignItems:'center', width: '500px', display: 'flex',}}>
                            <Typography
                              style={{
                                marginTop: tab === 0 ? '30px' : '110px',
                                color: '#6B6C6C', // Custom size
                              }}
                            >
                              Apple
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                    <FormControl margin="normal" sx={{ marginLeft: '10px'}}>
                      <FormLabel id="showModal">Mostrar como modal: </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="showModal"
                        name="row-radio-show-modal"
                      >
                        <FormControlLabel 
                          disabled= {justLook} 
                          checked={currentPlantilla.mostraModal ?? ""} 
                          value={true} 
                          control={<Radio sx={{
                            color: `${themePalette.GAINSBORO}`,
                            '&.Mui-checked': {
                              color: `${themePalette.BONDIBLUE}`, // Color when selected
                            },
                          }} />} 
                          label="Sí" 
                        />
                        <FormControlLabel 
                          disabled= {justLook} 
                          checked={!currentPlantilla.mostraModal} 
                          value={false}  
                          control={<Radio sx={{
                            color: `${themePalette.GAINSBORO}`,
                            '&.Mui-checked': {
                              color: `${themePalette.BONDIBLUE}`, // Color when selected
                            },
                          }} />} 
                          label="No" 
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Card variant="outlined" sx={{ width: '32.5vw'}}>
                      <CardContent>
                        <ModalContainerBox>
                          <Box
                            sx={{
                              // border: '4px solid gray',
                              borderRadius: '12px',
                              display: 'flex',
                              flexDirection: 'column',
                              // justifyContent: tab == 1 ? 'left' : 'space-between',
                              alignItems: 'left',
                              width: '250px',
                              height: '325px',
                              // marginTop: '120px',
                              // marginLeft: '1vw',
                              padding: '5px',
                              position: 'absolute',  // Makes this box stack on top
                              zIndex: 1,  // Ensures it's layered over the other box
                              backgroundColor: 'white'
                            }}
                          > 
                            <Box
                              sx={{
                                position: 'absolute',
                                top: '-5px',
                                right: '-5px',
                                width: '25px',
                                height: '25px',
                                borderRadius: '50%',
                                backgroundColor: 'lightgray',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: 'gray',
                                ':hover': {
                                  backgroundColor: 'darkgray',
                                  color: 'white'
                                }
                              }}
                            >
                              X
                            </Box>
                            <Box
                              sx={{
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column', // Stack items vertically
                                alignItems: 'center', // Center items horizontally
                                width: '100%',
                                paddingTop: '1vh',
                                // paddingLeft: '5vw', // Optional
                              }}
                            >
                              <Typography
                                  style={{
                                    fontSize: '12px', // Custom size
                                    fontWeight: 'bold',
                                    marginBottom: '2vh'
                                  }}
                                >
                                  Mi Espol | FIEC
                              </Typography>
                              <Typography
                                  style={{
                                    fontSize: '10px', // Custom size
                                    fontWeight: 'normal',
                                    justifyContent: 'center',
                                    textAlign:'center',
                                    marginLeft: '8px',
                                    marginRight: '8px',
                                    marginBottom:'8px'
                                  }}
                                >
                                  {currentPlantilla.contenido ?? ""}
                              </Typography>
                              <img 
                                  src={ (currentPlantilla.urlImagen === null || currentPlantilla.urlImagen === '') ? placeholderImage : currentPlantilla.urlImagen} 
                                  alt="icon" 
                                  style={{ height: 'auto', width: '8vw' }} 
                               />
                            </Box>
                          </Box>
                        </ModalContainerBox>
                      </CardContent>
                    </Card>          
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          ))}
          <ConfirmationModal isOpen={isOpenConfirmacion} message={"¿Estás seguro de que quieres cancelar esta campaña?"} onConfirm={() => { setIsOpenConfirmacion(false)}} onClose={() => { setIsOpenConfirmacion(false)}} ></ConfirmationModal>
        </div>
    );
}

